export default __webpack_public_path__ + "static/media/icons-grc-platforms.07e1d38e.svg";